<button
  (click)="onClicked()"
  class="flex sm:flex-row lg:justify-evenly items-center lg:px-3 lg:gap-2 h-[47px] lg:rounded-lg lg:shadow-[0px_4px_4px_0px_rgba(0,0,0,0.25)] lg:border lg:border-cafe lg:hover:bg-[#FFECCE] hover:cursor-pointer text-cafe text-base font-medium font-['Roboto']"
>
  <ng-content select="[icon]"></ng-content>
<!--  class="hidden lg:block"-->
  <span [ngClass]="[currentScreenSize() ==='LG' ? 'block' : 'hidden']">{{ label }}</span>
</button>
